export default __webpack_public_path__ + "static/media/dental-college.cbcba0b2.jpg";